export const getOverallRanking = (state) => state.ranking?.overallRanking;
export const getMyOverallRanking = (state) => state.ranking?.myRanking;
export const getMyWeeklyRanking = (state) => state.ranking?.myWeeklyRanking;
export const getRoundRanking = (state) => state.ranking?.roundRanking;
